export default class BackToTop {
  constructor({ el }) {
    this.el = el;
    this.button = this.el.querySelector('button');

    this.init();
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }

    if (this.el.dataset.scroll === 'true') {
      window.addEventListener(
        'scroll',
        () => {
          if (window.scrollY > 300) {
            this.el.classList.add('active');
          } else {
            this.el.classList.remove('active');
          }
        },
        { passive: true }
      );
    }
  }
}
